// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 284 ? "ba1712fc" : chunkId) + "." + {"284":"6b79f54ebaf3b365","606":"dc9d839072feb30a","699":"4c9abdd56c800ef5"}[chunkId] + ".js";
};